export default __webpack_public_path__ + "static/media/3.5a8624e0.png";